import React from 'react';
import styled from 'styled-components';
import cssConstants from '../../constants/cssConstants';

export const HeaderWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
`;

const LeftLabel = styled.h2<{hideRightLabelInMobileView: boolean}>`
   font-weight: 600;
   font-size: 1rem;
   margin: 0;
   text-overflow: ${props => props.hideRightLabelInMobileView ? 'ellipsis' : 'auto'};
   overflow: ${props => props.hideRightLabelInMobileView ? 'hidden' : 'auto'};
`;

const RightLabel = styled.div<{hideRightLabelInMobileView: boolean}>`
   font-size: .875rem;
   margin-right: 1rem;
   text-overflow: ${props => !props.hideRightLabelInMobileView ? 'ellipsis' : 'auto'};
   overflow: ${props => !props.hideRightLabelInMobileView ? 'hidden' : 'auto'};

   @media screen and (max-width: ${cssConstants.contentBreakpoint}px) {
      display: ${props => props.hideRightLabelInMobileView ? 'none' : 'block'};
   }
`;

const LeftTabHeaderSection = styled.div<{hideRightLabelInMobileView: boolean}>`
   overflow: ${props => !props.hideRightLabelInMobileView ? 'visible' : 'hidden'};
   margin-right: .5rem;
`;

const RightTabHeaderSection = styled.div<{$allowButtonOverflow: boolean}>`
   display: flex;
   align-items: center;
   overflow: ${props => props.$allowButtonOverflow ? 'visible' : 'hidden'};
`;

const TabHeader: React.FC<ITabHeaderProps> = ({button, leftLabel, rightLabel, hideRightLabelInMobileView, allowButtonOverflow}) => (
   <HeaderWrapper>
      <LeftTabHeaderSection hideRightLabelInMobileView={hideRightLabelInMobileView}>
         <LeftLabel hideRightLabelInMobileView={hideRightLabelInMobileView}>{leftLabel}</LeftLabel>
      </LeftTabHeaderSection>
      <RightTabHeaderSection $allowButtonOverflow={allowButtonOverflow} >
         <RightLabel hideRightLabelInMobileView={hideRightLabelInMobileView}>{rightLabel}</RightLabel>
         {button}
      </RightTabHeaderSection>
   </HeaderWrapper>
);

export default TabHeader;

export interface ITabHeaderProps {
   leftLabel: string;
   rightLabel: string;
   button: React.ReactElement;
   hideRightLabelInMobileView: boolean;
   allowButtonOverflow?: boolean;
}
